import React from "react";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { FormikValues, useFormik } from "formik";
import { CreateUserSchema } from "./../validations/Schema";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import { useNavigate, useLocation } from "react-router-dom";
import MuiButton from "./../components/basicComponent/MuiButton";
import { UserModel } from "./../model/controlPanelModels/CreateUserModel";

const BankDetail = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Add Bank Details   </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                    <div className="col-md-4">
                        <MuiInput
                          label="Beneficiary name "
                          placeholder="Beneficiary name "
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          label="Bank Name"
                          placeholder="Bank Name"
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          label="Account Number"
                          placeholder="Account Number"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label="SWIFT Code" placeholder="Enter SWIFT Code" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label="Currency" placeholder="Enter Currency" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label="Bank Address" placeholder="Enter Bank Address" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label="IBAN" placeholder="Enter IBAN" />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label="Branch"
                          placeholder="Select Branch"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      </div>

                 
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Add Details"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                        {/* <MuiButton
                        label={editingUser ? "Update User" : "Create User"}
                        className="main-btn"
                        variant="contained"
                        size="large"
                        onClick={() => formik.handleSubmit()}
                      /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </main>
          </div>
          </div>
        
      
    

   
  );
};

export default BankDetail;
